export const setErrors = errors => ({
  type: 'SET_ERRORS',
  payload: errors
})

export const setServerTime = dateTime => ({
  type: 'SET_SERVERTIME',
  payload: dateTime
})

export const setElementPosition = element => ({
  type: 'SET_POSITION',
  payload: element
})

export const setMediaQuery = mediaQuery => ({
  type: 'SET_MEDIAQUERY',
  payload: mediaQuery
})
